angular.module('env.data.services.gridDataProvider', [])

    .service('gridDataProvider', function ($log, $customisationConfig, orderItemsRepository, usersRepository,
                                           customResourceResolver, omqlAliasBuilder, gridTextSearchService,
                                           orderItemsGridSharedSettings, toastr, gettextCatalog, $q) {
        var _this = this;

        _.extend(_this, {
            getGridConfig: getGridConfig,
            getData: getData,
            getReportQuery: getReportQuery
        });

        return _this;

        /**
         * Get Grid configuration according to the current user and step.
         * @param {string} forStep step code of current step
         * @returns {Promise} promise of grid configuration
         */
        function getGridConfig(forStep) {
            return customResourceResolver.resolveConfig("grid-config", null, {step: forStep});
        }

        /**
         * Get data for grid according to grid filtering/sorting and additional filters
         * @returns {Promise<{items:RepresentationModel[], pageNumber: number, rowsPerPage: number, totalCount: number, totalPageCount: number}>} promise of search results object
         */
        function getData() {
            return $q.all([
                buildWhereString(), //Builds where string according to the search term entered by user in 'search box' on the grid toolbar
                buildSortString()  //Builds sort string according to the sorting applied over grid's columns headers
            ])
                .then(function (data) {
                    var whereString = data[0];
                    var sortString = data[1];

                    var forStep = orderItemsGridSharedSettings.getStepFilter() || "all-open";
                    var pageIndex = (orderItemsGridSharedSettings.getPageNumber() || 1) - 1; // OMQL use zero-based page number
                    var pageSize = orderItemsGridSharedSettings.getPageSize();
                    if (!angular.isDefined(pageSize) || pageSize === null) {
                        pageSize = 10; //set default page size
                    }

                    if (orderItemsGridSharedSettings.getForceIgnorePageSize()) {
                        //If we were asked to ignore page size (i.e. to load all items to select particular item to view)
                        pageSize = 0;
                    }

                    if (orderItemsGridSharedSettings.getIsExclusiveSelection()) {
                        //If we were asked to load the order item exclusively (i.e.: a direct link to the order item)
                        //so we don't want to load all of them
                        whereString = 'OrderItem.Id = ' + orderItemsGridSharedSettings.getSelectedOrderItemId();
                    }


                    $log.debug("Search query for step '%s':", forStep);
                    $log.debug(whereString);
                    $log.debug(sortString);

                    return orderItemsRepository.search({
                        where: whereString,
                        orderBy: sortString,
                        pageNumber: pageIndex,
                        rowsPerPage: pageSize
                    });
                })

                .then(function (resp) {
                    // fix for page number and selection
                    resp.pageNumber = (resp.pageNumber || 0) + 1; // OMQL use zero-based page number
                    if (resp.totalCount <= 0 || resp.totalPageCount === 0) {
                        resp.pageNumber = 1;
                    } else if (resp.pageNumber > resp.totalPageCount) {
                        orderItemsGridSharedSettings.setPageNumber(resp.totalPageCount);

                        //Re-set the page size only if we are not in 'page size ignore force mode'
                        if (!orderItemsGridSharedSettings.getForceIgnorePageSize()) {
                            orderItemsGridSharedSettings.setPageSize(angular.isDefined(resp.rowsPerPage) ? resp.rowsPerPage : 10);
                        }
                        $log.debug("Making additional search request to fix page information...");
                        return getData();
                    }

                    orderItemsGridSharedSettings.setPageNumber(resp.pageNumber);

                    if (!orderItemsGridSharedSettings.getForceIgnorePageSize()) {
                        //Remember the page size only if we were not in 'forced' mode
                        orderItemsGridSharedSettings.setPageSize(resp.rowsPerPage);
                    }

                    return resp;
                });
        }

        /**
         * Get query for report generators representing the current context shown by the gridDataProvider
         * @returns {Promise<{query: string, orderBy: string}>} report query object
         */
        function getReportQuery() {
            return $q.all([
                buildWhereString(), //Builds where string according to the search term entered by user in 'search box' on the grid toolbar
                buildSortString() //Builds sort string according to the sorting applied over grid's columns headers
            ])
                .then(function (data) {
                    var whereString = data[0];
                    var sortString = data[1];
                    return {
                        query: whereString,
                        orderBy: sortString
                    };
                });
        }

        /**
         * @return {Promise<string>}
         */
        function buildWhereString() {
            //Either use the custom OMQL configured in the customisation config for the custom filter (if specified)
            //Or just build the OMQL 'where' string based on the 'step' name filter and any text search applied

            return $q.all([
                // See if we have any 'ignored' steps in workflow config meaning we don't want to get items for those steps
                buildStepsFilterForIgnoredSteps(),
                // See if we have dates supplied meaning we're about to show completed items for particular period
                buildDatesFilterIfAny(),
                // Text search for customisable number of fields
                buildTextSearchFilterIfAny(),
                //Builds filter string according to the filter chosen in the grid's columns filter
                buildFilterStringIfAny()
            ])
                .then(function (data) {
                    var stepsFilter = data[0];
                    var datesFilter = data[1];
                    var textSearchFilter = data[2];
                    var fieldsFilter = data[3];

                    //The final 'where' string
                    var forStep = orderItemsGridSharedSettings.getStepFilter() || "all-open";
                    var customFilter = orderItemsGridSharedSettings.getCustomFilter();

                    var whereString;

                    //TODO: We might want to further refactor the approach to use special term to distinguish the mode 'existing step' or virtual view
                    //where 'all-open' is a virtual view just like any other specified for the brand custom config
                    if (forStep === 'all-open') {
                        if (!customFilter) {
                            //we're querying over orderItems ignoring specified as 'ignore=true' in config steps plus adding dates filter if specified so
                            //(however, we ignore stepFilter if datesFilter was specified to filter by completion date )
                            //plus to be safe and not have empty 'where' clause in case we don't have ignored steps and dates filter,
                            //we specify that we want only not deleted items
                            whereString = 'OrderItem.Deleted = false' + (stepsFilter.length > 0 && (!datesFilter || datesFilter.length === 0)
                                    ? ' AND ' + stepsFilter : '') + (datesFilter.length > 0 ? ' AND ' + datesFilter : '');
                        } else {
                            //Use the custom OMQL query from custom filter defined in the customisation config to be applied to the view.
                            //This query specified amongst one or more custom filters and particular query to use specified via $stateParams
                            //by putting it's id/name in the URI used to navigate to the OrderItemsGridView
                            whereString = customFilter.queryForStatInfo;
                        }

                        //Then add the fields filters based on the 'kendo grid filters' applied by a user on columns in the Grid UI 
                        //and also any 'text search term' filter applied via the search textbox
                        whereString += 
                            (fieldsFilter.length > 0 ? ' AND ' + fieldsFilter : '') +
                            (textSearchFilter.length > 0 ? ' AND ' + textSearchFilter : '');
                    } else {
                        //we're querying over orderItems at particular step.
                        //we want to show non deleted and non completed items at that step
                        //datesFilter string will contain the filter for dates fields to include non completed only
                        whereString =
                            'OrderItem.Deleted = false' +
                            (forStep ? _.string.sprintf(" AND Step.Code = '%s'", forStep) : '') +
                            (datesFilter.length > 0 ? ' AND ' + datesFilter : '') +
                            (fieldsFilter.length > 0 ? ' AND ' + fieldsFilter : '') +
                            (textSearchFilter.length > 0 ? ' AND ' + textSearchFilter : '');
                    }

                    return whereString;
                });
        }

        /**
         * @return {Promise<string>}
         */
        function buildFilterStringIfAny() {
            var filterByFields = orderItemsGridSharedSettings.getGridFilter();
            if (!filterByFields) {
                filterByFields = {filters: [], logic: "and"};
            }

            var parseFilterDescriptor = function (fDescriptor) {
                var filterString = "";
                var logic = fDescriptor.logic;
                var filters = fDescriptor.filters;
                if (filters) {
                    //Iterate over filters 
                    filterString += " (";
                    for (var i = 0; i < filters.length; i++) {
                        if (!filters[i]) continue;
                        var filter = filters[i];
                        if (filter.filters) {
                            //parse filters collection recursively
                            filterString += parseFilterDescriptor(filter);
                        } else {
                            //parse single filter descriptor for the field
                            var omqlField = omqlAliasBuilder.mapFieldToOrderItemAlias(filter.field);
                            if (_.string.contains(omqlField, "undefined.")) {
                                //Just warn user about what columns will be ignored in filtering
                                toastr.warning(_.str.sprintf("The column '%s' does not support filtering",
                                    _.str(filter.field).strRightBack(".").capitalize().value()), gettextCatalog.getString("Please try again"));
                            } else {
                                if (i > 0) {
                                    filterString += _.str.sprintf(" %s ", logic);
                                }

                                //Get omql query according to the specified logic operator (=, <, >, etc.), field name and value and its type
                                filterString += omqlAliasBuilder.buildOperatorQuery(filter.operator, omqlField, filter.value);
                            }
                        }
                    }
                    filterString += ") ";
                }
                return filterString;
            };

            return getDefaultFiltersFromConfig()
                .then(function (defaultFilters) {
                    //Add default filters from config to the filters selected by user in the UI
                    filterByFields.filters = _.union(defaultFilters, filterByFields.filters);

                    if (!filterByFields.filters || filterByFields.filters.length === 0) return "";

                    return parseFilterDescriptor(filterByFields);
                });
        }

        function buildSortString() {
            var sortByFields = orderItemsGridSharedSettings.getGridSort();

            var sortString = "";
            //Apply default sorting by date of creation if no user-specific sorting applied
            if (!sortByFields || sortByFields.length === 0) return "OrderItem.Created desc";

            for (var i = 0; i < sortByFields.length; i++) {
                if (!sortByFields[i]) continue;
                var field = omqlAliasBuilder.mapFieldToOrderItemAlias(sortByFields[i].field);
                if (_.string.contains(field, "undefined.")) {
                    //Just warn user about what columns will be ignored in sorting
                    toastr.warning(
                        _.str.sprintf("The column '%s' does not support sorting", _.str(sortByFields[i].field).strRightBack(".").capitalize().value()),
                        gettextCatalog.getString("Please try again"));
                } else {
                    var direction = sortByFields[i].dir;
                    sortString += _.string.sprintf("%s %s, ", field, direction);
                }
            }

            return $q.when(_.string.rtrim(sortString, ", "));
        }

        /**
         * @return {Promise<string>}
         */
        function buildDatesFilterIfAny() {
            var completedFilter = orderItemsGridSharedSettings.getCompletedFilter();
            var createdFilter = orderItemsGridSharedSettings.getCreatedFilter();

            var filterString = '';

            if (createdFilter && createdFilter.enabled && createdFilter.from && createdFilter.to) {
                //We're showing completed orders/orderItems, so build the filter for dates when items were
                //marked as completed. And set 'from' to the beginning of the day and 'to' to the end of the day
                createdFilter.from.setHours(0, 0, 0, 0);
                createdFilter.to.setHours(23, 59, 59, 999);

                //we need timestamp without the milliseconds part, so omql api will understand it
                //OMQL DateTimeFormat = "yyyy-MM-ddTHH:mm:ss". i.e.: AND OrderItem.Completed = #0001-01-01T00:00:00#
                filterString = _.string.sprintf('OrderItem.Created >= #%s# AND OrderItem.Created <= #%s#', 
                    createdFilter.from.toISOString(), createdFilter.to.toISOString());

            }

            if (completedFilter && completedFilter.enabled && completedFilter.from && completedFilter.to) {
                //We're showing completed orders/orderItems, so build the filter for dates when items were
                //marked as completed. And set 'from' to the beginning of the day and 'to' to the end of the day
                completedFilter.from.setHours(0, 0, 0, 0);
                completedFilter.to.setHours(23, 59, 59, 999);
                
                //we need timestamp without the milliseconds part, so omql api will understand it
                //OMQL DateTimeFormat = "yyyy-MM-ddTHH:mm:ss". i.e.: AND OrderItem.Completed = #0001-01-01T00:00:00#

                if (filterString && filterString.length > 0) {
                    filterString += ' AND ';
                }

                filterString += _.string.sprintf('OrderItem.Completed >= #%s# AND OrderItem.Completed <= #%s#',
                    completedFilter.from.toISOString(), completedFilter.to.toISOString());

            }

            return $q.when(filterString);
        }

        /**
         * @return {Promise<string>}
         */
        function buildTextSearchFilterIfAny() {
            var textFilter = orderItemsGridSharedSettings.getTextSearch();

            if (!textFilter || !textFilter.text || textFilter.text.length < 1) {
                return $q.when("");
            }
            return gridTextSearchService.getCriteria(textFilter.text, !!textFilter.exact).then(function(criteria) {
                if (criteria.length > 0) {
                    return "(" + criteria.join(" OR ") + ")";
                }
                return "";
            });
        }

        /**
         * @return {Promise<string>}
         */
        function buildStepsFilterForIgnoredSteps() {
            return customResourceResolver.resolveWorkflow()
                .then(function (workflowConfig) {
                    if (!workflowConfig) {
                        return;
                    }
                    var stepsConfig = workflowConfig.steps;
                    var ignoredSteps = _.where(stepsConfig, {ignore: true});

                    return _
                        .map(ignoredSteps, function (s) {
                            return _.string.sprintf("Step.Code <> '%s'", s.code);
                        })
                        .join(" AND ");
                });
        }

        /**
         * @return {Promise<object>}
         */
        function getDefaultFiltersFromConfig() {
            return customResourceResolver
                .resolveConfig("grid-config", null, {step: orderItemsGridSharedSettings.getStepFilter() || "all-open"})
                .then(function (gridConfig) {
                    return usersRepository.getCurrentUser()
                        .then(function (currentUser) {
                            var defaultFilters = gridConfig && gridConfig.defaultFilters
                                ? gridConfig.defaultFilters
                                : [];
                            for (var i = 0; i < defaultFilters.length; i++) {
                                var f = defaultFilters[i];
                                if (f && f.value && f.value.indexOf('%me%') !== -1) {
                                    f.value = f.value.replace('%me%', currentUser.$model.name);
                                }
                            }
                            return defaultFilters;
                        });
                });
        }

    })

;
